/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Signup_Price_Monthly_DisplayInputs */

const en_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/month`)
};

const fr_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/mois`)
};

const de_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/Monat`)
};

const it_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/mese`)
};

const ru_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/месяц`)
};

const es_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/mes`)
};

const zh_cn2_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/月`)
};

const ja_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`月額$${i?.amount}`)
};

const hi_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/माह`)
};

const pt_pt2_signup_price_monthly_display = /** @type {(inputs: Signup_Price_Monthly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/mês`)
};

/**
* | output |
* | --- |
* | "${amount}/month" |
*
* @param {Signup_Price_Monthly_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_price_monthly_display = /** @type {((inputs: Signup_Price_Monthly_DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Price_Monthly_DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_price_monthly_display(inputs)
	if (locale === "de") return de_signup_price_monthly_display(inputs)
	if (locale === "it") return it_signup_price_monthly_display(inputs)
	if (locale === "ru") return ru_signup_price_monthly_display(inputs)
	if (locale === "es") return es_signup_price_monthly_display(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_price_monthly_display(inputs)
	if (locale === "ja") return ja_signup_price_monthly_display(inputs)
	if (locale === "hi") return hi_signup_price_monthly_display(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_price_monthly_display(inputs)
	return en_signup_price_monthly_display(inputs)
});